
angular.module('gallery').factory('Ads', ['$rootScope', function ($rootScope) {
	var counter = 0;
	var minDesctopWidth = 992;

	$rootScope.$on('updateMetaInfo', function () {
		if (!isDesktop()) {
			return;
		}
		updateCounter();
		refreshAds();
	});

	function updateCounter () {
		counter ++;
	}

	function refreshAds () {
		/*
		 * on every view of image slide, the counter will be updated by 1
		 * after 3 images scrolled pass, we will refresh the right rail ad
		 */
		if (counter < 3) {
			return;
		}

		var slotId = getSlotId();
		FsAds.refresh([slotId]);

		counter = 0;
	}

	function getSlotId(){

		var currentStory = getCurrentStory();

        var adContainerEl = document.querySelector('#story-' + currentStory + ' .right-rail > .fsAdContainer');

        return adContainerEl.id;

	}

	function getCurrentStory(){

		/* temporary remove until we have infinite scroll
        if (typeof FsCurrentStory !== 'undefined'){
            return FsCurrentStory;
        }else{
            return 1;
        }*/

        return 1;

    }

	function isDesktop () {
		if (minDesctopWidth <= window.innerWidth) {
			return true;
		}
		return false;
	}

	return {};
}]);



// WEBPACK FOOTER //
// ./assets/components/galleryPage/scripts/ads/adsService.js